module.exports = __webpack_public_path__ + "img/care-offer-4.55645b77.jpg";